import React from "react";

class ContactDivider extends React.Component {
  render() {
    return <div className="__d_p_divider" />;
  }
}

export default ContactDivider;
